import { nextTick } from 'vue'
import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { createRouterInstance } from './router'
import { trackPageView } from './composables/useAnalytics.js'
import 'modern-normalize/modern-normalize.css'
import './styles/main.scss'

const router = createRouterInstance(typeof window !== 'undefined')

export const createApp = ViteSSG(
  App,
  { routes: router.options.routes },
  ({ router: ssgRouter }) => {
    // Same-path navigations (search/filter updates via router.replace({ query })
    // on ResourceCentre/OurWork) shouldn't reset scroll to top — only a genuine
    // page change should. Those pages handle their own subtle scroll-to-results
    // after a search, rather than a hard jump here.
    ssgRouter.options.scrollBehavior = (to, from) => (
      to.path === from.path ? false : { top: 0 }
    )

    // The static gtag snippet's own `gtag('config', ...)` call already sends
    // the very first pageview automatically — this hook only covers
    // client-side navigations after that, or it would double-count page 1.
    let isFirstNavigation = true
    ssgRouter.afterEach((to, from, failure) => {
      if (isFirstNavigation) {
        isFirstNavigation = false
        return
      }
      if (failure) return
      // Query-only navigations (e.g. ResourceCentre.vue's filter/search state
      // sync via router.replace({ query })) aren't a new page — skip them so
      // they don't fire a spurious page_view alongside the intended custom
      // event.
      if (to.path === from.path) return
      // nextTick: wait for the new route's useHead() title update to commit
      // to document.title before reading it.
      nextTick(() => trackPageView(to.fullPath, document.title))
    })
  }
)
